// src/components/VideoModal.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/VideoModal.css';

export default function VideoModal({ isOpen, onClose, video }) {
  const { t } = useTranslation();

  if (!isOpen || !video) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // YouTube URL → embed URL変換
  const getYouTubeEmbedUrl = (url) => {
    try {
      const parsedUrl = new URL(url);
      let videoId = null;

      if (parsedUrl.hostname.includes('youtube.com')) {
        videoId = parsedUrl.searchParams.get('v');
      }

      if (parsedUrl.hostname.includes('youtu.be')) {
        videoId = parsedUrl.pathname.replace('/', '');
      }

      if (!videoId) return null;

      return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&playsinline=1&rel=0`;
    } catch {
      return null;
    }
  };

  const videoUrl = video.url;
  const youtubeEmbedUrl = video.type === 'youtube'
    ? getYouTubeEmbedUrl(videoUrl)
    : null;

  const isMp4 = video.type === 'mp4';

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="video-modal">
        <div className="video-content">

          <div className="video-frame-wrapper">
            {/* YouTube */}
            {youtubeEmbedUrl && (
              <iframe
                className="video-frame"
                src={youtubeEmbedUrl}
                title="YouTube video"
                allow="autoplay; encrypted-media; picture-in-picture"
                allowFullScreen
              />
            )}

            {/* mp4 */}
            {!youtubeEmbedUrl && isMp4 && (
              <video
                className="video-frame"
                src={videoUrl}
                autoPlay
                muted
                playsInline
                controls
              />
            )}

            {/* fallback */}
            {!youtubeEmbedUrl && !isMp4 && (
              <div className="video-error">
                動画が再生できません
              </div>
            )}
          </div>

          <div className="video-header">
            <h2 className="video-title">{video.name}</h2>
          </div>

          {video.description && (
            <p className="video-description">
              {video.description}
            </p>
          )}

          {/*
          {video.onRouteSearch && (
            <button
              onClick={video.onRouteSearch}
              disabled={video.routeLoading}
              style={{
                marginTop: '12px',
                padding: '10px',
                width: '100%',
                borderRadius: '8px',
                border: 'none',
                background: '#ff4d4f',
                color: '#fff',
                fontWeight: 'bold',
                cursor: video.routeLoading ? 'not-allowed' : 'pointer'
              }}
            >
              {video.routeLoading ? '経路検索中...' : 'ここまでの経路'}
            </button>
          )}
          */}
        </div>

        <button className="close-button" onClick={onClose}>
          {t('map.buttons.close')}
        </button>
      </div>
    </div>
  );
}